import { CustomAgGrid, createColDefs } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { protection } from '@/react-query/queries/ic-report/hooks'

export interface ProtectionBreakdownTableProps extends ICReportTablePrimitive {}

export const ProtectionBreakdownTable: React.FC<ProtectionBreakdownTableProps> = ({
  params,
  options,
}) => {
  const query = protection.useBreakdown(params)
  const data = query.data

  return (
    <CustomAgGrid loading={query.isLoading} rowData={data} columnDefs={colDefs()} {...options} />
  )
}

const colDefs = () => {
  return createColDefs([
    { field: 'unique_identifier', headerName: 'Unique Identifier' },
    { field: 'instrument_type', headerName: 'Instrument Type' },
    { field: 'under_unique_identifier', headerName: 'Under Unique Identifier' },
    { field: 'under_short_name', headerName: 'Under Short Name' },
    { field: 'asset_class', rowGroup: true, hide: true },
    {
      field: 'weight_pct',
      headerName: 'Weight (%)',
      valueFormatter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'delta_to_underlyings_pct',
      headerName: 'CS01/Delta (%)',
      valueFormatter: (params) => params.value?.toFixed(2),
    },
    {
      field: 'position_delta_risk_weight_pct',
      headerName: 'Weighted Delta (%)',
      valueFormatter: (params) => params.value?.toFixed(2),
    },
    { field: 'maturity_date', headerName: 'Maturity' },
  ])
}
